import styled from "@emotion/styled";
import { Box, Paper, css } from "@mui/material";

export const MetodoPagamentoItem = styled(Paper)<{selecionado?: boolean; isFirst?: boolean}>`
  width: 100%;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 16px;
  margin-top: ${props => props.isFirst ? '0' : '8px'};
  background-color: ${props => props.theme.palette.background.paper};
  border: none;

  ${props =>
    props.selecionado &&
    css`
      border: 2px solid ${props.theme.palette.primary.main};
      background-color: ${props.theme.palette.background.paper};
    `}

  &:hover {
    ${props =>
      !props.selecionado &&
      css`
        box-shadow: ${props.theme.shadows[2]};
      `}
  }
`;

export const MetodoPagamentoIconBox = styled(Box)<{
  tipoPagamento: 'pix' | 'dinheiro' | 'cartao';
  themeName?: 'light' | 'dark';
}>(({ tipoPagamento, themeName }) => {
  const getBgColor = () => {
    if (tipoPagamento === 'pix') {
      return themeName === 'dark' ? 'rgba(13, 148, 136, 0.2)' : '#f0fdfa';
    }
    if (tipoPagamento === 'dinheiro') {
      return themeName === 'dark' ? 'rgba(22, 163, 74, 0.2)' : '#f0fdf4';
    }
    // cartao
    return '#1976d2';
  };

  const getColor = () => {
    if (tipoPagamento === 'pix') {
      return '#0d9488';
    }
    if (tipoPagamento === 'dinheiro') {
      return '#16a34a';
    }
    // cartao
    return '#ffffff';
  };

  return css`
    width: 32px;
    height: 32px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${getBgColor()};
    color: ${getColor()};
    
    svg {
      font-size: 20px;
    }
  `;
});